var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTomoyoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "805px",
    height: "130px",
    viewBox: "0 0 805 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MD/Logo/Tomoyo/Color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E61D72",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE1721",
    x: 45,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE1721",
    x: 45,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#BE1721",
    x: 45,
    y: 90,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E9501B",
    x: 90,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F39200",
    points: "175 0 175 40 135 40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#F39200",
    x: 135,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    fill: "#F39200",
    points: "135 90 175 90 175 130"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FCEA0D",
    x: 180,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FCEA0D",
    x: 180,
    y: 90,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#95C21E",
    points: "225 0 265 40 225 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-7",
    fill: "#008D36",
    points: "270 0 310 40 270 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-11",
    fill: "#006533",
    points: "400 0 400 40 360 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-14",
    fill: "#2FAB66",
    points: "445 0 445 40 405 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-28",
    fill: "#951B81",
    points: "715 0 715 40 675 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-19",
    fill: "#35A9E1",
    points: "495 0 535 40 495 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-29",
    fill: "#E61C72",
    points: "765 0 805 40 765 40"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    fill: "#1E71B7",
    x: 540,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-26",
    fill: "#662383",
    x: 630,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    fill: "#04A19A",
    x: 450,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-30",
    fill: "#D50E52",
    x: 720,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#95C21E",
    x: 225,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#008D36",
    x: 270,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    fill: "#006533",
    x: 360,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    fill: "#2FAB66",
    x: 405,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    fill: "#951B81",
    x: 675,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    fill: "#35A9E1",
    x: 495,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-32",
    fill: "#E61C72",
    x: 765,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    fill: "#2D2E83",
    x: 585,
    y: 45,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-23",
    fill: "#1E71B7",
    points: "540 45 580 45 580 85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-27",
    fill: "#662383",
    points: "630 45 670 45 630 85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-10",
    fill: "#038D36",
    points: "315 45 355 85 315 85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    fill: "#95C21E",
    points: "225 90 265 90 225 130"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#008D36",
    x: 270,
    y: 90,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#006533",
    x: 360,
    y: 90,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-16",
    fill: "#2FAB66",
    points: "405 90 445 90 445 130"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-33",
    fill: "#951B81",
    points: "675 90 715 90 715 130"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-21",
    fill: "#35A9E1",
    points: "495 90 535 90 495 130"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-34",
    fill: "#E61C72",
    points: "765 90 805 90 765 130"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    fill: "#2D2E83",
    x: 585,
    y: 90,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    fill: "#04A19A",
    x: 450,
    y: 90,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-35",
    fill: "#D50E52",
    x: 720,
    y: 90,
    width: 40,
    height: 40
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTomoyoLogo);
export default __webpack_public_path__ + "static/media/tomoyoLogo.42c815e8544578af4d16ed268a31a781.svg";
export { ForwardRef as ReactComponent };